import React, { useRef } from "react";
import { Col, Form, Input, message, Modal, Row } from "antd";
import { connect } from "dva";

const TransferVehicleModal = props => {
  const { transferVehicleId, shipmentData, dispatch, loadingTransferVehicle } = props;
  const transferVehicleFormRef = useRef();

  const handleTransferVehicle = () => {
    transferVehicleFormRef.current.validateFields().then(result => {
      const vehicleId = transferVehicleId;
      const { shipmentId } = shipmentData;
      const transferShipmentId = result.shipmentId;

      dispatch({
        type: "shipmentDetails/removeVehicleShipment",
        vehicleId,
        shipmentId,
        payload: {
          shipmentId: transferShipmentId,
        },
      }).then(res => {
        if (!res) {
          message.error("Could not transfer vehicle.");
        } else {
          dispatch({
            type: "shipmentDetails/setTransferVehicleId",
            payload: null,
          });
          message.success("Successfully transferred vehicle.");
        }
      });
    });
  };

  return (
    <Modal
      title="Transfer Vehicle"
      open={transferVehicleId}
      onOk={handleTransferVehicle}
      onCancel={() => {
        dispatch({
          type: "shipmentDetails/setTransferVehicleId",
          payload: null,
        });
      }}
      confirmLoading={loadingTransferVehicle}
    >
      <Form layout="vertical" ref={transferVehicleFormRef}>
        <Row gutter={16}>
          <Col flex={1}>
            <p>Please enter full shipment ID of shipment to transfer to.</p>
            <Form.Item name="shipmentId" label="Shipment ID" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default connect(({ shipmentDetails, loading }) => ({
  shipmentData: shipmentDetails.data[0],
  transferVehicleId: shipmentDetails.transferVehicleId,
  loadingTransferVehicle: loading.effects["shipmentDetails/removeVehicleShipment"],
}))(TransferVehicleModal);
